// removed by extract-text-webpack-plugin
module.exports = {"container":"medium-comment-form__container__299Qq","comment-input":"medium-comment-form__comment-input__3HU_c","post-button-container":"medium-comment-form__post-button-container__1ixkT","post-button":"medium-comment-form__post-button__VTGIh","post-button-disabled":"medium-comment-form__post-button-disabled__2fZ4n medium-comment-form__post-button__VTGIh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/media/medium-comment-form.scss
// module id = 1427
// module chunks = 1